import { createSlice } from "@reduxjs/toolkit"

export const Dashboard = createSlice({
    name : 'dashboard',
    initialState : {
        rex_data_dashboard: null,
        rex_link_dashboard: null,
        rex_state_dashboard: false,
        rex_powerbi_public: null,
        rex_powerbi_private: null,
        rex_dataset_id: null,
    },
    reducers : {
        storeDataDashboard: (state, action) => {
            state.rex_data_dashboard = action.payload
        },
        storeLinkDashboard: (state, action) => {
            state.rex_link_dashboard = action.payload
        },
        storeStateDashboard: (state, action) => {
            state.rex_state_dashboard = action.payload
        },
        storePowerBIPublic: (state, action) => {
            state.rex_powerbi_public = action.payload
        },
        storePowerBIPrivate: (state, action) => {
            state.rex_powerbi_private = action.payload
        },
        storeDatasetId: (state, action) => {
            state.rex_dataset_id = action.payload
        },
    }
})

export default Dashboard.reducer
export const { 
    storeDataDashboard, 
    storeLinkDashboard, 
    storeStateDashboard,
    storePowerBIPublic,
    storePowerBIPrivate,
    storeDatasetId
} = Dashboard.actions